import { REHYDRATE } from 'redux-persist/constants';
import { PERSIST_STORE_VERSION } from 'constants/App';
import { updatePersistStoreVersion, logout } from 'actions';

const persistPostProcess = (store) => (next) => (action) => {
  switch (action.type) {
    case REHYDRATE:
      // Check persistStore version
      if (!action.payload.version || (action.payload.version && PERSIST_STORE_VERSION !== action.payload.version.persistStore)) {
        // Purge persist store
        store.getState().persist.persistor.purge();
        // Do not propagate next to stop rehydratation
        // Instead, store new version
        next(updatePersistStoreVersion(PERSIST_STORE_VERSION));
        // Now, logout user
        store.dispatch(logout());
      } else {
        next(action);
      }
      break;
    default:
      next(action);
      break;
  }
};

export default persistPostProcess;



// WEBPACK FOOTER //
// ./middlewares/persistPostProcess.js